import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
import Modal from './modal_doc_perusahaan';
import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import he from 'he';
import {utils, writeFile} from 'xlsx';


const title_form = "DATA PERUSAHAAN / GROUP";
const sub_title_form = ""
const tipedata = "PERUSAHAAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_URL_ONLINE;



const API_mkt_google_search = mainhost + "mkt/google_result"
const API_mkt_google_daftar_keyword = mainhost + "mkt/google_daftar_keyword"



const GoogleSearch = () => {
  const token = localStorage.getItem('token');

  const tableGoogle = useRef(null); 
  const [TokenNew, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const config = apiConfig(token);
  const [dataPencarian, setDataPencarian] = useState([]);

  const saveKeyword = async () => {
    setIsLoading(true);
    try {

      const formData = new FormData();
      formData.append('keyword', document.getElementById('keyword').value);
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_mkt_google_daftar_keyword}`, formData, config);
      const data = response.data;
      if(data.status == "error"){
        alert("From Server : "+data.message);
      } 
      console.log(data.result);
      if (typeof data.result == "object"){
        setDataPencarian(data.result);
      } 
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
      alert("Server Not Responding");
    }
    setIsLoading(false);
  }
  const searchGoogle = async () => {
    try {

      const formData = new FormData();
      formData.append('keyword', document.getElementById('search').value);
        const response = await axios.post(`${API_mkt_google_search}`, formData, config);
      const data = response.data;
      if(data.status == "error"){
        alert("From Server : "+data.message);
      } 
      console.log(data);
      // if (typeof data.result == "object"){
        setDataPencarian(data);
      // } 
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
      alert("Server Not Responding");
    }
  }


  const exportToExcel = (data_excel, filename) => {
    const workbook = utils.book_new();
  
    // Loop through each sheet data object
    data_excel.forEach((sheet) => {
      const worksheet = utils.json_to_sheet(sheet.data);
  
      // Add optional column headers if defined
      if (sheet.columns) {
        utils.sheet_add_aoa(worksheet, sheet.columns, { origin: 'A1' });
      }
  
      // Append the sheet to the workbook
      utils.book_append_sheet(workbook, worksheet, sheet.name);
    });
    writeFile(workbook, filename+'.xlsx');
  };
  
  const TableGoogle = () => {

    // Proses tableGoogle
    const dataTable_sum = tableGoogle.current;
    const data = [];

    // Extract headers from the table
    const headers = Array.from(dataTable_sum.querySelectorAll('thead th')).map((th) => th.textContent);

    // Extract data from the table body
    const tableBody = dataTable_sum.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    const dataRows = rows.map((row) => Array.from(row.querySelectorAll('td')).map((td) => td.textContent));

    return [headers, dataRows];
  }

  const onDownloadAllClean  = () => {
    const data = [];

    const tabGoogle = TableGoogle();
    const headersGoogle = tabGoogle[0];
    const dataRowsGoogle= tabGoogle[1];

    // Combine headers and data into the desired format
    data.push({
      name: 'Google Search',
      data: [...dataRowsGoogle],
      columns : [headersGoogle]
    });

    exportToExcel(data,'Excel All Numeric');
  }
  useEffect(() => {
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

  }, []);

  const TextArea120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '240px',
    height: '85vh',
    marginTop: '5px',
  };
  const inputStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '18px',
    marginTop: '5px',
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  return (
    <div>
      <HeaderMenu title={"Google Search"} subtitle={"Google Search"} />
      {/* <ToastContainer /> */}
      <div style={{ height:'90vh', overflowY:'auto'}}>
        <table ref={tableGoogle}>
          <tr>
            <td>
              <textarea type="text" id="keyword" name="keyword" style={TextArea120} className='input input-sm'></textarea>
            </td>
            <td>
              <button type="button" className="btn btn-primary" style={selectStyle120} onClick={saveKeyword}>Submit Keyword</button>
            </td>
            <td style={{ verticalAlign:"top"}}>
              <input type="text" id="search" name="search" style={inputStyle120} ></input>
              <button type="button" className="btn btn-primary" style={selectStyle120} onClick={searchGoogle}>Search</button>
              <button onClick={onDownloadAllClean} className="btn btn-info"> Export Excel</button>
              <div className="container" style={{ height:'80vh', overflowY:'auto'}}>
                <table className='table table-bordered' style={{ width:"100vh"}}>
                  <thead>
                    <tr>
                      <th>Keyword</th>
                      <th>Link</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Meta Title</th>
                      <th>Meta Desc</th>
                    </tr>
                  </thead>
                  <tbody>
                { isLoading ? <tr><td colSpan="6">Loading...</td></tr> : null }
                {dataPencarian.map((item, index) => (
                  <tr>
                    <td>{he.decode(item.keyword)}</td>
                    <td>{he.decode(item.url)}</td>
                    <td style={{ width :"220px"}}>{he.decode(item.title)}</td>
                    <td style={{ width :"420px"}}>{he.decode(item.description)}</td>
                    <td style={{ width :"220px"}}>{he.decode(item.meta_title)}</td>
                    <td style={{ width :"420px"}}>{he.decode(item.meta_description)}</td>
                  </tr>
                ))}
                </tbody>
                </table>
              </div>
            </td>
          </tr>
        </table>

      </div>
    </div>
  );
};


export default GoogleSearch;